import { Typography } from 'antd'
import { DefaultMessageProps } from './types'

/**
 * ```typescript
 * `Defaults to: ${noQuotes ? value : `"${value}"`}`
 * ```
 */
const DefaultMessage: React.VFC<DefaultMessageProps> = ({
  noQuotes,
  value,
}) => (
  <Typography.Paragraph type="secondary" style={{ marginBottom: 0 }}>
    {`Defaults to: ${noQuotes ? value : `"${value}"`}`}
  </Typography.Paragraph>
)

export default DefaultMessage
